import { useEffect, Dispatch } from 'react';
import { useTranslation } from '@core/hooks';

interface RowData {
  [dataItem: string]: string | number;
}

export const useMainPopupTitle = (data: RowData, dataItem: string, setPopupTitle: Dispatch<string>) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (data[dataItem] && !data.mode) {
      setPopupTitle(`${data[dataItem]} - ${t('Edycja')}`);
    } else {
      setPopupTitle('');
    }
  }, []);
};
